'use client';

import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import NextLink from 'next/link';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <div className="flex flex-col gap-2 mx-auto my-auto items-center p-4">
      <h2 className="tds-heading-lg">Tehniline viga</h2>
      <p className="tds-body-md text-semantic-content-subtle">
        Vabandame, tekkis tehniline probleem. Kasuta otsingut, et leida vajalik
        leht või mine avalehele.
      </p>
      {error?.digest && (
        <p className="tds-body-md text-semantic-content-subtle">
          <span className="font-bold">Vea ID: </span>
          {error?.digest}
        </p>
      )}
      <Button
        renderLink={({ children, ...props }) => {
          return <NextLink {...props}>{children}</NextLink>;
        }}
        className="w-max"
        href="/"
      >
        Mine avalehele
      </Button>
    </div>
  );
}
